export default {
  name: 'misc.situation',
  key: 'situation',
  attributes: {
    dark: {
      key: 'dark',
      name: 'entity.moonBase.situation.dark',
    },
    criminals: {
      key: 'criminals',
      name: 'entity.moonBase.situation.criminals',
    },
    plague: {
      key: 'plague',
      name: 'entity.moonBase.situation.plague',
    },
    supplies: {
      key: 'supplies',
      name: 'entity.moonBase.situation.supplies',
    },
    rich: {
      key: 'rich',
      name: 'entity.moonBase.situation.rich',
    },
  },
};
